import * as Counter from './App/Counter';
import * as UnifyHeights from './App/UnifyHeights';
import * as PageScroll from './App/PageScroll';
import * as ContactFilter from './App/ContactFilter';
import * as InfinityScroller from './App/InfinityScroller';
import * as OffCanvas from './App/OffCanvas';
import * as AnimatedBarGraphs from './App/AnimatedBarGraphs';
import * as FollowToMenu from './App/FollowToMenu';
import * as GoogleReCaptcha from './Spinao/GoogleReCaptcha';
import * as NetteAjaxForm from './Spinao/NetteAjaxForm';
import * as OverlayDialog from './Spinao/OverlayDialog';

$(document).ready(function () {
    Counter.initialize();
    UnifyHeights.initialize('.product-content');
    UnifyHeights.initialize('.reference-block');
    UnifyHeights.initialize('.feature-production-content');
    UnifyHeights.initialize('.feature-production-title');
    UnifyHeights.initialize('.feature-content');
    UnifyHeights.initialize('.feature-content2');
    PageScroll.initialize();
    ContactFilter.initialize();
    InfinityScroller.initialize();
    OffCanvas.initialize();
    AnimatedBarGraphs.initialize();
    FollowToMenu.initialize();
    NetteAjaxForm.initialize('[data-ajax="form"]');
    GoogleReCaptcha.initialize();
    OverlayDialog.initialize();

    if(getCookie('corporate-bar', null) === null) {
        let corporateBarCounter = getCookie('corporate-bar-counter', 0)*1;
        if(corporateBarCounter < 2) {
            setCookie('corporate-bar-counter', corporateBarCounter+1)
            setTimeout(
                showCompanyBar,
                document
                    .querySelector('[data-corporate-bar-timer]')
                    .getAttribute('data-corporate-bar-timer')*1
            );
        } else {
            showCompanyBar();
        }
    }
});


function showCompanyBar()
{
    if(getCookie('corporate-bar', null) === null) {
        $('#corporate-bar-choice').removeClass('d-none');
        setCookie('corporate-bar-counter', 2);

        gtagevent({'event': 'track_show_bar'});

        document.querySelectorAll('[data-corporate-choice]').forEach(function(element) {
            element.addEventListener('click', function(e) {
                e.preventDefault();
                chooseCompanyBar(element.getAttribute('data-corporate-choice'));
                $('#corporate-bar-choice').addClass('d-none');
                $('#corporate-bar-success').removeClass('d-none');
                setTimeout(function(){
                    $('#corporate-bar-success').addClass('d-none');
                },5000);
            })
        });
    }
}

function chooseCompanyBar(selected)
{
    setCookie('corporate-bar', selected, 365);
}

function setCookie(name,value,days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name, defaultValue) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return defaultValue;
}

